// extracted by mini-css-extract-plugin
module.exports = {"block":"_5851","hd":"_7566","icon":"_19658","title":"_11695","grow":"_12528","arrow":"_8501","bd":"_16584"};